import { Box, SxProps } from '@mui/material'
import { ReactNode } from 'react'

export interface PlanPurchaseExperienceSummaryLineContainerProps {
  children?: ReactNode
  sx?: SxProps
}

export function PlanPurchaseExperienceSummaryLineContainer(
  props: PlanPurchaseExperienceSummaryLineContainerProps
): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-between',
        gap: '0 16px',
        ...props.sx
      }}
    >
      {props.children}
    </Box>
  )
}
